import React, {useEffect} from 'react'
import { Box } from '@mui/system'
import Sidebar from './sidebar'
import { Button } from '@mui/material';

import { DataGrid } from '@mui/x-data-grid';
import CustomToolbar from './CustomToolbarPrint';
import { useNavigate } from 'react-router-dom';
import "../App.css"


import { doc, addDoc, collection, query, getDocs, deleteDoc, onSnapshot } from "firebase/firestore"; 
import {db} from "../firebase.js";

import { darken, lighten } from '@mui/material/styles';


const getBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

const getHoverBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);

  
 


export default function ExpirySoon() {
  const [rows, setRows] = React.useState([])

  let arr = [];
  let expiry =[]


  useEffect( () => {
    test()

    async function test(){
      arr=[]
      expiry=[]
      getData()
    }

    setRows(expiry)
    console.log(rows)

}, []);


async function getData (){
  
  let arr = []
  let expiry = []

  const q = query(collection(db, "employee"));
  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    let obj = doc.data();
    Object.assign(obj, {doc: doc.id});
   // console.log(obj)
    obj.qualification.forEach((e)=>{
      
      let d1 = new Date(e.date);
      let today = new Date();
      let difference = d1 - today;
      let days = Math.round(difference/(1000*60*60*24));
  
      let pass;
      if(days <= 0){
        pass = {
          color: "red-data-grid",
          data: obj,
          name: e.qualification,
          date: e.date,
          dname: obj.firstName,
          days: days,
          id: Date.now()*Math.random()
         
        }
      } else if(days <= 30){
        pass = {
          color: "orange-data-grid",
          data: obj,
          name: e.qualification,
          date: e.date,
          dname: obj.firstName,
          days: days,
          id: Date.now()*Math.random()
         
        }
      } else if (days <= 60){
        pass = {
          color: "green-data-grid",
          data: obj,
          name: e.qualification,
          date: e.date,
          dname: obj.firstName,
          days: days,
          id: Date.now()*Math.random()
      
        }
      }
      if(pass != undefined){
        expiry.push(pass);
      }
      
    })

    obj.training.forEach((e)=>{
       
      let d1 = new Date(e.date);
      let today = new Date();
      let difference = d1 - today;
      let days = Math.round(difference/(1000*60*60*24));
  
      let pass;
      if(days <= 0){
        pass = {
          color: "red-data-grid",
          data: obj,
          name: e.training,
          date: e.date,
          dname: obj.firstName,
          days: days,
          id: Date.now()*Math.random()
       
        }
      } else if(days <= 30){
        pass = {
          color: "orange-data-grid",
          data: obj,
          name: e.training,
          date: e.date,
          dname: obj.firstName,
          days: days,
          id: Date.now()*Math.random()
          
        }
      } else if (days <= 60){
        pass = {
          color: "green-data-grid",
          data: obj,
          name: e.training,
          date: e.date,
          dname: obj.firstName,
          days: days,
          id: Date.now()*Math.random()
         
        }

      }
      if(pass != undefined){
        expiry.push(pass);
      }
      
    })


    arr.push(obj)
   });  
   console.log(expiry)
   setRows(expiry)

}



  const navigate = useNavigate();
  const columns = [
   // { field: 'id', headerName: 'ID', width: 70 },
    { field: 'dname', headerName: 'Name', width: 150 },
 
    {
        field: 'name',
        headerName: 'Qualification/Traning',
        width: 370 
        
      },
      { field: 'date', headerName: 'Expiry Date' , width: 150 },
      { field: 'days', headerName: 'Days Left/Exceded' , width: 150 },
    
      
  
    
  ];

  const handleRowClick = (params) => {
    //console.log(params.row);
    navigate("/profile",{
      state: {
        employee: params.row.data,
      }
    });
  };
  
  return (

      

      <Box sx={{ display: 'flex' }}>
        <Sidebar />
     
        <div style={{ height: 640, width: '100%'}}>
        <Box
      sx={{
        height: 640,
        width: '100%',
        '& .red':{
          bgcolor: (theme) => {
            getBackgroundColor("rgb(0,0,0)", "dark")
          }
        }
       
        
      }}
      style={{marginTop: "50px", justifyContent: "center", alignItems: "center"}}
    >
              <DataGrid
                  rows={rows}
                  columns={columns}
                  pageSize={10}
                  rowsPerPageOptions={[5]}
                  onRowDoubleClick={handleRowClick}
                  getRowClassName={(params) => `${params.row.color}`}
                  components={{
                    Toolbar: CustomToolbar,
                  }}
              />

            </Box>
          </div>
          
        <Box component="main" sx={{ flexGrow: 1, p: 3 }} style={{marginTop: "50px", justifyContent: "center", alignItems: "center"}}>
       
        
        
      </Box>
     
        
    </Box>

    
  )
}
